import { CoverageRecommendation } from "../types";

export const COVERAGE_RECOMMENDATION_LABELS: Record<CoverageRecommendation, string> = {
  pass: "Pass",
  consider: "Consider",
  recommend: "Recommend",
};

export const deriveCoverageRecommendation = (average: number | null): CoverageRecommendation => {
  if (average === null) {
    return "pass";
  }
  if (average >= 3.5) {
    return "recommend";
  }
  if (average >= 2.5) {
    return "consider";
  }
  return "pass";
};

export const getRecommendationLabel = (
  value: CoverageRecommendation | null | undefined,
  derived: CoverageRecommendation
): { label: string; isDerived: boolean } => {
  if (value) {
    return { label: COVERAGE_RECOMMENDATION_LABELS[value], isDerived: false };
  }
  return { label: COVERAGE_RECOMMENDATION_LABELS[derived], isDerived: true };
};
